const API_URL = process.env.VUE_APP_API_URL || 'https://graphql.dev.wheezo.com/graphql';
const API_REGION = process.env.VUE_APP_REGION || 'us-east-1';

export { API_URL, API_REGION };
